var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      [
        _c(
          "a-form-model",
          {
            staticStyle: {
              "border-bottom": "1px solid #dbd7d7",
              "margin-bottom": "20px"
            },
            attrs: {
              model: _vm.form,
              "label-col": _vm.labelCol,
              "wrapper-col": _vm.wrapperCol
            }
          },
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query1") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.custno) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query2") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.mblno) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query3") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              width: "134px"
                            },
                            attrs: { title: _vm.formShow.cntrtotal }
                          },
                          [_vm._v(" " + _vm._s(_vm.formShow.cntrtotal))]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query4") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.cbm) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query5") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.kgs) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query6") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.pkgs) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query8") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.customername) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query9") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.portdischarge) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query10") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.vessel) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query11") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.voyno) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query12") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.sale) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query13") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formShow.etd
                                ? _vm.formShow.etd.substring(0, 10)
                                : ""
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query14") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.blfrt) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c("a-form-model-item", {
                      attrs: { label: _vm.$t("query7") }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c("a-form-model-item", {
                      attrs: { label: _vm.$t("query15") }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query16") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.destination) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: _vm.$t("query17") } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formShow.portload) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 24 } },
                  [
                    _c("a-form-model-item", {
                      attrs: {
                        "label-col": { span: 1 },
                        "wrapper-col": { span: 23 },
                        label: _vm.$t("query18")
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-spin",
          { attrs: { spinning: _vm.loading } },
          [
            _c("div", { staticClass: "opera" }, [
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "bold", "margin-right": "20px" }
                },
                [_vm._v("应收")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.handleAdd } }, [
                _vm._v("添加")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.handleCopy } }, [
                _vm._v("复制")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.handleSave } }, [
                _vm._v("保存")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn blue", on: { click: _vm.handleInto } },
                [_vm._v("模板引入")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn red", on: { click: _vm.handleDelete } },
                [_vm._v("删除")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn blue", on: { click: _vm.handleClear } },
                [_vm._v("清空缓存并刷新")]
              ),
              _vm._v(" "),
              _c("div", { style: { color: _vm.tips ? "green" : "red" } }, [
                _vm._v(_vm._s(_vm.tips ? "" : "有数据未保存"))
              ])
            ]),
            _vm._v(" "),
            _c("ve-table", {
              ref: "tableRef",
              staticClass: "tableRef",
              attrs: {
                "max-height": 300,
                "checkbox-option": _vm.checkboxOption,
                rowKeyFieldName: "rowKey",
                "scroll-width": 0,
                "border-x": true,
                "fixed-header": true,
                columns: _vm.columns,
                "table-data": _vm.tableData,
                cellSelectionOption: _vm.cellSelectionOption,
                editOption: _vm.editOption,
                "cell-style-option": _vm.cellStyleOption,
                rowStyleOption: _vm.rowStyleOption,
                "border-y": ""
              },
              nativeOn: {
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleMoveA.apply(null, arguments)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown"
                      ])
                    ) {
                      return null
                    }
                    return _vm.handleDownA.apply(null, arguments)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "opera" }, [
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "bold", "margin-right": "20px" }
                },
                [_vm._v("应付")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.handleAddB } }, [
                _vm._v("添加")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleCopyB } },
                [_vm._v("复制")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.handleSave } }, [
                _vm._v("保存")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn blue", on: { click: _vm.handleIntoB } },
                [_vm._v("模板引入")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn red", on: { click: _vm.handleDeleteB } },
                [_vm._v("删除")]
              ),
              _vm._v(" "),
              _c("div", { style: { color: _vm.tipsB ? "green" : "red" } }, [
                _vm._v(_vm._s(_vm.tipsB ? "" : "有数据未保存"))
              ])
            ]),
            _vm._v(" "),
            _c("ve-table", {
              ref: "tableRefB",
              staticClass: "tableRefB",
              attrs: {
                "max-height": 300,
                "checkbox-option": _vm.checkboxOptionB,
                rowKeyFieldName: "rowKey",
                "scroll-width": 0,
                "border-x": true,
                "fixed-header": true,
                columns: _vm.columnsB,
                "table-data": _vm.tableDataB,
                cellSelectionOption: _vm.cellSelectionOptionB,
                editOption: _vm.editOption,
                "cell-style-option": _vm.cellStyleOption,
                rowStyleOption: _vm.rowStyleOption,
                "border-y": ""
              },
              nativeOn: {
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleMoveB.apply(null, arguments)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown"
                      ])
                    ) {
                      return null
                    }
                    return _vm.handleDownB.apply(null, arguments)
                  }
                ]
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-modal",
          {
            attrs: {
              title: "模板引入",
              width: "1200px",
              visible: _vm.tempFlag
            },
            on: {
              ok: _vm.handleSave,
              cancel: function($event) {
                _vm.tempFlag = false
              }
            }
          },
          [
            _c("a-table", {
              attrs: {
                rowSelection: {
                  selectedRowKeys: _vm.selectedRowKeys,
                  onChange: _vm.onSelectChange,
                  type: "radio"
                },
                rowKey: "id",
                loading: _vm.tempLoad,
                size: "small",
                pagination: false,
                columns: _vm.columnsTemp,
                "data-source": _vm.tempList,
                bordered: ""
              }
            }),
            _vm._v(" "),
            _c(
              "template",
              { slot: "footer" },
              [
                _c("a-spin", { attrs: { spinning: _vm.intoLoad } }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn",
                      staticStyle: { width: "100px", "margin-left": "90%" },
                      on: { click: _vm.sureInto }
                    },
                    [_vm._v("引入")]
                  )
                ])
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc2d8efa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc2d8efa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/index.vue
// module id = null
// module chunks = 